import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdown = styled<any, any>(
    'div',
    'filterDropdown',
    'filterItemDropdown'
)`
    ${propStyles};
    ${top};
`;

FilterDropdown.defaultProps = {
    position: 'absolute',
    top: 'calc(100% + 1px)',
    left: '0',
    right: '0',
    zIndex: 'dropdown',
    padding: 'md',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
    overflow: 'hidden',
};

export default FilterDropdown;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterDropdown.tsx